<template>
  <!--
    multipleSelection 实现跨页问题 主要是回显问题
    回显问题 数据结构一定要统一 不然有问题
  -->
  <!-- 选择询价商品 -->
  <el-dialog
    title="选择询价商品"
    :visible.sync="selectProductsVisible"
    width="800px"
    :before-close="cancelHandle"
    :close-on-click-modal="false"
    append-to-body
    class="select-products"
  >
    <div class="search-box">
      <el-form ref="listQuery" :model="listQuery" size="small" class="search-form">
        <el-form-item label="商品名称：" label-width="92px" prop="">
          <el-input v-model="listQuery.skuname" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label-width="30px">
          <div class="search-btn">
            <div class="btn reset-btn" size="small" @click="handleReset">重置</div>
            <div class="btn submit-btn" size="small" @click="handleSearch">查询</div>
          </div>
          <!-- <el-button @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="list-box">
      <el-table
        ref="tableData"
        v-loading="tabelLoading"
        :data="tableData"
        max-height="252"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column :selectable="checkboxSelect" type="selection" width="55px"></el-table-column>
        <el-table-column
          prop="skuname"
          label="商品名称"
          show-overflow-tooltip
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="specificationstr"
          label="规格型号"
          min-width="150"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="unitvalue" label="计量单位" width="80px" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <el-pagination
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, prev, pager, next"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <div slot="footer">
      <eui-btn type="primary" class="submit-btn btn" @click="getSelectProducts">确定</eui-btn>
      <!-- <el-button type="primary" @click="selectProducts" size="small"
        >确定</el-button
      > -->
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import multipleSelection from './multipleSelection/multipleSelection.js';

export default {
  components: { EuiBtn },
  mixins: [multipleSelection],
  props: {
    selectProductsVisible: {
      type: Boolean,
      default: false,
    },
    selectProductsList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tabelLoading: false,
      listQuery: {
        skuname: '',
        pageNum: 1,
        pageSize: 10,
        datafrom: 1,
      },
      cloneSelectProductsForm: {},
      total: 0,
      tableData: [],
      // 确保唯一
      idKey: 'skuid',
      skuids: [],
    };
  },
  watch: {
    selectProductsVisible(oldVal, newVal) {
      if (oldVal) {
        const { listQuery } = this.$options.data();
        this.cloneSelectProductsForm = {
          // ...utils.cloneDeep(this.listQuery),
          ...listQuery,
        };
        console.log(this.selectProductsList, 'this.selectProductsList');
        this.multipleSelectionAll = [...this.selectProductsList];
        this.skuids = this.selectProductsList.map((item) => {
          return item.skuid;
        });

        this.getList(this.cloneSelectProductsForm);
      }
    },
  },
  methods: {
    checkboxSelect(row, rowIndex) {
      if (row.enable) {
        return false; // 禁用
      }
      return true; // 不禁用
    },
    /* getRowKey(row) {
      return row.skuid;
    }, */
    // 获取列表数据
    async getList(params) {
      this.tabelLoading = true;
      await Api.queryProductPage(params).then((res) => {
        this.tabelLoading = false;
        if (res.code === '200') {
          const list = res.data?.list;
          list.forEach((item) => {
            // this.$set(item, "unitName", item.unitvalue);
            item.unitName = item.unitvalue;
            // this.$set(item, "brandName", item.brandname);
            item.brandName = item.brandname;
            // this.$set(item, "categoryName", item.category);
            item.categoryName = item.category;
            // this.$set(item, "categoryCode", item.categoryid);
            item.categoryCode = item.fourthcategorycode || item.thirdcategorycode;
            item.categoryId = item.categoryid;
            // this.$set(item, "productName", item.skuname);
            item.productName = item.skuname;
            // this.$set(item, "specifications", item.specificationstr);
            item.specifications = item.specificationstr;
            // this.$set(item, "mySkuId", item.skuid);
            item.mySkuId = item.skuid;
            // 需求数量
            item.requiredQuantity = item.requiredQuantity || '';
            item.productDescription = '';
          });
          this.skuids.forEach((skuid) => {
            list.forEach((item) => {
              if (item.skuid === skuid) {
                item.enable = true;
              }
            });
          });
          console.log(list, 'listlist');
          this.tableData = [...res.data?.list];

          this.setSelectRow();
          this.total = res.data?.total;
        }
      });
    },
    // 搜索
    handleSearch() {
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneSelectProductsForm };
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      // 改变页的时候调用一次
      // this.changePageCoreRecordData();
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      // this.changePageCoreRecordData();
      this.listQuery.pageSize = val;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleSelectionChange(val) {
      this.multipleSelection = [...val];
      this.getAllSelectionData();
    },
    cancelHandle() {
      this.listQuery = { ...this.cloneSelectProductsForm };
      this.$emit('update:selectProductsVisible', false);
      this.clearTable();
    },

    // 点击确定 获取到选择的商品
    getSelectProducts() {
      if (this.multipleSelectionAll.length < 1) {
        this.$message({
          message: '请选择需要处理的数据',
          type: 'warning',
        });
        return;
      }
      console.log(this.selectProductsList, 'this.selectProductsList');
      const newArr = [...this.multipleSelectionAll, ...this.selectProductsList];
      console.log(newArr, '发送的数据');
      this.$emit('getSelectProducts', newArr);
      this.multipleSelectionAll = [];
      this.$nextTick(() => {
        this.clearTable();
        this.cancelHandle();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table .cell.el-tooltip {
  white-space: nowrap;
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.select-products {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  /* .list-box {
    max-height: 260px;
  } */

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
</style>
